import React from 'react';
import './Footer.css';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer__inner">
        <div className="footer__grid">
          {/* Brand */}
          <div className="footer__brand">
            <div className="footer__brand-logo">
              <img src="https://www.dola.co.za/client/images/header/logo.png" alt="Dola Money" className="footer__brand-logo-img" />
            </div>
            <p className="footer__brand-desc">
              We're here to help you resolve your account and find a path forward.
              Your financial wellbeing matters to us.
            </p>
          </div>

          {/* Contact */}
          <div className="footer__links">
            <h3 className="footer__links-title">Contact</h3>
            <div className="footer__contact-item">
              <span className="footer__contact-icon" aria-hidden="true">📞</span>
              <span>011 568 2963 / 011 568 2964</span>
            </div>
            <div className="footer__contact-item">
              <span className="footer__contact-icon" aria-hidden="true">✉️</span>
              <span>customercare@dola.co.za</span>
            </div>
            <div className="footer__contact-item">
              <span className="footer__contact-icon" aria-hidden="true">🕐</span>
              <span>Mon–Fri, 8am–5pm</span>
            </div>
          </div>
        </div>

        <hr className="footer__divider" />

        {/* Bottom Bar */}
        <div className="footer__bottom">
          <span className="footer__copyright">
            © {currentYear} Dola Money (Pty) Ltd. All rights reserved. NCRCP14262.
          </span>
          <div className="footer__legal">
            <a href="https://www.dola.co.za/Home/Privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
            <a href="https://www.dola.co.za/Home/Terms" target="_blank" rel="noopener noreferrer">
              Terms &amp; Conditions
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
